import GlobalStore from './globalStore'

const ua =  navigator.userAgent.toLocaleLowerCase() || ''

const isAndroid = /android/i.test(ua)

const isIos = /iphone|ipad|ipod/i.test(ua)

const getIOSVersion = () => {
  if ( isIos ) {
    const version = ua.match(/os (\d+)_(\d+)_?(\d+)?/) as string[]
    return Number.parseInt(version[1], 10)
  }
}
const IOSVersion = getIOSVersion()

// 是否iphonx及以上刘海屏手机
const ioIPhoneX =  window.screen.height >= 812 && window.devicePixelRatio >= 2

const isHighPhone = window.screen.height >= 812

// ubox
const isUboxApp = ua.indexOf('ubox') > -1

// ubox IOS打开
const isUboxIosApp = ua.indexOf('ubox-app-ios') > -1

// ubox安卓打开
const isUboxAndroidApp = ua.indexOf('ubox-app-android') > -1

// 微信中打开
const isWechat = /micromessenger\/([\d.]+)/i.test(ua)

// 微信小程序中打开
const isWechatMiniProgram = /miniprogram/.test(ua) || window?.__wxjs_environment == 'miniprogram'

// QQ中打开
const isQQ = /qq\/([\d.]+)/i.test(ua)

// hupu app 中打开
const isHp = window.location.search.indexOf('source=hpweb') > -1 || GlobalStore.getGlobal()?.source === 'hpweb'

// 区分是否是移动端
const isPhone=/phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone/i.test(ua)

// 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器
export const isOriginalChrome =
  /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua) && isAndroid && ua.indexOf('Version') < 0

// 在 非app/微信小程序/其他联运App 中
const isNotAppWebview = !isUboxApp && !isHp && !isWechatMiniProgram

/**
 * 获取当前执行环境
 *
 * @return string
 */
const getPlatformType = () => {
  switch (true) {
    case isQQ:
      return 'qq'
    case isWechat:
      return 'wechat'
    case isUboxIosApp:
      return 'uboxIosApp'
    case isUboxAndroidApp:
      return 'uboxAndroidApp'
    default:
      return 'brower'
  }
}

const platformType = getPlatformType()

export default {
  isAndroid,
  isIos,
  IOSVersion,
  ioIPhoneX,
  isWechat,
  isWechatMiniProgram,
  isQQ,
  isHp,
  isUboxApp,
  isUboxIosApp,
  isUboxAndroidApp,
  isPhone,
  isHighPhone,
  type: platformType,
  isOriginalChrome,
  isNotAppWebview,
}